import 'bulma/css/bulma.css';
import './hero.css';

const Hero = () => {
    return (
        <div className="hero">
            <img src="./img-intern/wzc-de-vliet.jpg" alt="Avatar" class="image" />
            <div class="overlay">
                <div class="text">Hello World</div>
            </div>
        </div>
    );
};

export default Hero;

const Hero1 = () => {
    return (
        <div className="custom-body">
            <div className="card h-100 custom-card">
                <img src="./img-intern/wzc-de-vliet.jpg" alt="WZC De Vliet" className="card-img-top post-img" />
                <div className="card-body">
                    <h5 className="card-title">Campus De Vliet</h5>
                    <div className="card-text">Wil je meer te weten komen over Campus De Vliet?</div>
                    <a href="https://www.zorgnetwerktrento.be" target="_top" className="btn btn-primary stretched-link">
                        Ontdek meer
                    </a>
                </div>
            </div>
        </div>
    );
};

const Hero2 = () => {
    return (
        <div className="custom-body">
            <div className="card h-100 custom-card">
                <img src="./img-intern/wzc-de-vliet.jpg" alt="WZC De Vliet" className="card-img-top post-img" />
                <div className="card-body">
                    <h5 className="card-title">Campus De Vliet</h5>
                    <div className="card-text">Wil je meer te weten komen over Campus De Vliet?</div>
                    <a href="https://www.zorgnetwerktrento.be" target="_top" className="btn btn-primary stretched-link">
                        Ontdek meer
                    </a>
                </div>
            </div>
        </div>
    );
};

const Hero3 = () => {
    return (
        <section className="hero is-danger is-fullheight">
            <div className="hero-body">
                <div className="">
                    <p className="title">Half height hero</p>
                    <p className="subtitle">Half height subtitle</p>
                </div>
            </div>
        </section>
    );
};

const Hero4 = () => {
    return (
        <section className="hero is-warning is-fullheight">
            <div className="hero-body">
                <div className="">
                    <p className="title">Half height hero</p>
                    <p className="subtitle">Half height subtitle</p>
                </div>
            </div>
        </section>
    );
};

export { Hero1, Hero2, Hero3, Hero4 };
